import React, { Component } from "react";

class TestCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      test: props.test, // Initialize with test instance
      showDetails: false // Track details visibility
    };
  }

  componentDidMount() {
    // Subscribe to updates from the test instance
    this.state.test.on("update", this.handleTestUpdate);
  }

  componentWillUnmount() {
    // Unsubscribe to prevent memory leaks
    this.state.test.off("update", this.handleTestUpdate);
  }

  handleTestUpdate = updatedTest => {
    this.setState({ test: updatedTest });
  };

  getStatusEmoji(status) {
    switch (status) {
      case "success":
        return "✅"; // Checkmark
      case "warning":
        return "⚠️"; // Warning
      case "error":
        return "❌"; // Crossmark
      case "running":
        return "🔄"; // Refresh
      default:
        return "⏳"; // Hourglass
    }
  }

  toggleDetails = () => {
    this.setState(prevState => ({ showDetails: !prevState.showDetails }));
  };

  shouldDisplayTest(test) {
    if (this.state.testFilter === "failed")
      return test.result && !test.result.success;
    if (this.state.testFilter === "passed")
      return test.result && test.result.success;
    return true;
  }

  render() {
    const { test, showDetails } = this.state;

    return (
      <div className="bg-white shadow-lg rounded-lg p-6 w-full border border-gray-200 mb-4">
        <div className="flex items-center mb-4">
          <div className="text-3xl flex items-center justify-center">
            {this.getStatusEmoji(test.status)}
          </div>
          <h3 className="text-lg font-semibold text-gray-800 ml-4">
            {test.name}
          </h3>
        </div>
        <p className="text-sm text-gray-600 mb-4">{test.message}</p>
        <div className="mb-4 flex items-center gap-4 text-sm">
          <button
            className="bg-gray-100 py-2 px-4 rounded-lg hover:bg-gray-200 transition"
            onClick={this.toggleDetails}
          >
            {showDetails ? "Hide Details" : "View Details"}
          </button>
        </div>
        {showDetails && (
          <div className="mt-4 bg-gray-100 p-2 rounded pt-4">
            <div className="mb-2">
              <button
                onClick={() => this.setState({ testFilter: "all" })}
                className="bg-blue-200 rounded py-1 px-2 mr-1"
              >
                All
              </button>
              <button
                onClick={() => this.setState({ testFilter: "failed" })}
                className="bg-red-200 rounded py-1 px-2 mr-1"
              >
                ❌ Failed
              </button>
              <button
                onClick={() => this.setState({ testFilter: "passed" })}
                className="bg-green-200 rounded py-1 px-2 mr-1"
              >
                ✅ Passed
              </button>
            </div>
            {test.tests
              .filter(t => this.shouldDisplayTest(t))
              .map((t, index) => (
                <div key={index} className="mb-2">
                  <span className="text-xl">
                    {this.getStatusEmoji(
                      t.result ? (t.result.success ? "success" : "error") : ""
                    )}
                  </span>
                  <a
                    href={t.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ml-2 text-blue-600 hover:underline"
                  >
                    {index + 1}. {t.name}
                  </a>
                  <p className="text-gray-600 text-sm ml-8">
                    {t.result?.message || ""}
                  </p>
                </div>
              ))}
          </div>
        )}
        <div className="relative w-full h-2 bg-gray-200 rounded-full overflow-hidden mt-4">
          <div
            className={`h-full ${
              test.status === "success"
                ? "bg-green-500"
                : test.status === "error"
                  ? "bg-red-500"
                  : "bg-blue-500"
            }`}
            style={{ width: `${test.progress}%` }}
          ></div>
        </div>
        {test.status === "running" && (
          <p className="text-sm text-blue-500 mt-2">
            Running... {test.progress.toFixed(0)}%
          </p>
        )}
      </div>
    );
  }
}

export default TestCard;
